module.exports = __webpack_public_path__ + "static/media/ico-meetings.214b95ed.svg";